import { VolleyballEventStatusId } from '@collector/sportsapi-client-legacy'

import { PitchBlockedEventStatus } from '../../configuration'

export const pitchBlockedEventStatus: PitchBlockedEventStatus<VolleyballEventStatusId> =
  new Set([
    VolleyballEventStatusId.Abandoned,
    VolleyballEventStatusId.Cancelled,
    VolleyballEventStatusId.NotStarted,
    VolleyballEventStatusId.StartDelayed,
    VolleyballEventStatusId.Postponed,
    VolleyballEventStatusId.Interrupted,
    VolleyballEventStatusId.ToFinish,
    VolleyballEventStatusId.Finished,
    VolleyballEventStatusId.FinishedAwardedWin,
    VolleyballEventStatusId.BreakAfterFirstSet,
    VolleyballEventStatusId.BreakAfterSecondSet,
    VolleyballEventStatusId.BreakAfterThirdSet,
    VolleyballEventStatusId.BreakAfterFourthSet,
    VolleyballEventStatusId.BreakAfterFifthSet,
  ])
